export { DateMode as ViewMode } from 'choerodon-ui/dataset/data-set/enum';
export var TimeUnit;
(function (TimeUnit) {
    TimeUnit["hour"] = "h";
    TimeUnit["minute"] = "m";
    TimeUnit["second"] = "s";
    TimeUnit["a"] = "a";
})(TimeUnit || (TimeUnit = {}));
